import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

export default function CustomFieldValue({ definition, value }) {
  const { i18n } = useTranslation();
  if (value === null || value === undefined || value === '') {
    return <span className="text-slate-400">—</span>;
  }

  switch (definition.field_type) {
    case 'boolean':
      return value
        ? <Check size={14} className="text-emerald-500" />
        : <span className="text-slate-400">—</span>;
    case 'date':
      try {
        const d = new Date(`${value}T00:00:00`);
        return <span>{d.toLocaleDateString(i18n.language)}</span>;
      } catch {
        return <span>{value}</span>;
      }
    case 'number':
      return <span className="tabular-nums">{Number(value).toLocaleString(i18n.language)}</span>;
    case 'select': {
      const opt = (definition.options || []).find((o) => o.value === value);
      return <span>{opt?.label ?? value}</span>;
    }
    case 'text':
    default:
      return <span>{String(value)}</span>;
  }
}
